import { run as runActions } from '../../../../store/workspaces/workspaces/run';

export const onActionComplete = (modalStates, workspaceActions) => {
  const eventKey = modalStates.multiUpload.widgetData?.events?.find((event) => event.type === 'onClick')?.key;
  runActions(eventKey, workspaceActions.id, { ...workspaceActions, upload: modalStates.multiUpload.widgetData.upload });
};